var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleUnverified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2382.4 2500",
    viewBox: "0 0 2382.4 2500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1862.6 2155.8c-165.5 166-370.1 288.5-597.6 344.3-587-143.8-1022.8-732.6-1022.8-1363.8v-601.3l-242.2-241.9 192-192.1 2190.4 2190.5-191.9 192zm-742.1-742.2-83 83-293.7-293.8-160.8 160.8 454.5 454.5 243.8-243.8zm540.6-219 507.9 507.7c76.3-176.2 118.5-369.1 118.5-566v-681.8l-1022.5-454.5-552.9 245.6 788.3 788.1 285.5-285.5 160.8 160.9z",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleUnverified);
export default __webpack_public_path__ + "static/media/google-unverified.ca413a1d4999ba3c1d5ac92425d51c1d.svg";
export { ForwardRef as ReactComponent };